import React from "react"

import AboutSectionDesktop from "./AboutSectionDesktop"
import AboutSectionMobile from "./AboutSectionMobile"

const AboutSection = ({ section, practice, theme, highlightedField, viewMode = "", deviceType = "desktop" }) => {
  // If viewMode is explicitly set (from preview), use that to determine which component to show
  if (viewMode === "mobile") {
    return (
      <AboutSectionMobile section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
    )
  }

  if (viewMode === "desktop") {
    return (
      <AboutSectionDesktop section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
    )
  }

  // Use server-side device detection for public pages
  if (deviceType === "mobile") {
    return (
      <AboutSectionMobile section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
    )
  }

  // Default to desktop for desktop devices
  return <AboutSectionDesktop section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
}

export default AboutSection
